import React from "react";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { CategoryEnhancedGridSectionResult } from "~/common/Store/models/Category";
const Tiles = ({
  sections,
  descriptionStyle
}: {
  sections: CategoryEnhancedGridSectionResult[];
  descriptionStyle?: React.CSSProperties;
}) => <ul className="ag-carousel" data-sentry-component="Tiles" data-sentry-source-file="Tiles.tsx">
    {sections.map(section => <li className="ag-item carousel-item" key={section.description}>
        <a className="carousel__card" href={section.link}>
          <div className="carousel__image">
            <NoScriptLazyImage alt={section.description} src={section.imagePath} className="" dataTestId="CarouselImage" height="100%" />
          </div>
          <h3 className="carousel__card-title" style={descriptionStyle}>
            {section.description}
          </h3>
        </a>
      </li>)}
  </ul>;
export default Tiles;